import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {

  const user = sessionStorage.getItem("UserName");

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;